import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Paper, Typography, List, ListItem, ListItemText, IconButton, Fab } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import AddIcon from '@mui/icons-material/Add';
import PrescriptionModalRouter from '../prescriptionModal/prescriptionModalRouter';
import Loading from '../../../../components/loading';
import SuccessMessage from '../../../../components/successMessage';
import ErrorMessage from '../../../../components/errorMessage';
import api from "../../../../api/api";

export default function PrescriptionListMobile() {

    const navigate = useNavigate();

    const { patientId } = useParams();
    
    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [prescriptions, setPrescriptions] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);


    const obterReceituariosDoPaciente = useCallback(() => {
        if (!patientId) return;
        setLoading(true);
        api.get("/receituario/".concat(patientId), {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);
            setPrescriptions(returnFromApi.data);
        }).catch((returnFromApi) => {
            setLoading(false);
            console.error(returnFromApi);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        });
    }, [patientId, navigate]);

    useEffect(() => {
        obterReceituariosDoPaciente();
    }, [obterReceituariosDoPaciente]);

    const onSavePrescription = (returnFromApi) => {
        if (returnFromApi.data) {
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
        } else {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
        }
        setModalOpen(false);
        obterReceituariosDoPaciente();
    };

    const printPrescription = (prescriptionId) => {
        window.open(`/prescription-to-print/${patientId}/${prescriptionId}`, "_blank");
    };

    return (
        <>
            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>

                <Loading isToHidden={isLoading === false} />
                {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
                {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Receituários
                </Typography>

                {prescriptions.length === 0 ? (
                    <Typography align="center" sx={{ py: 4 }}>
                        Nenhuma receita cadastrada ainda.
                    </Typography>
                ) : (
                    <List disablePadding>
                        {prescriptions.map(p => (
                            <ListItem 
                                key={p.receituarioId} 
                                divider
                                secondaryAction={
                                    <IconButton color="primary" onClick={() => printPrescription(p.receituarioId)}>
                                        <PrintIcon />
                                    </IconButton>
                                }
                            >
                                <ListItemText 
                                    primary={`Data: ${p.data}`}
                                    secondary={p.nomeDoDentista}
                                    primaryTypographyProps={{fontWeight: 'bold'}}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
            </Paper>

            <Fab
                color="primary"
                aria-label="adicionar receituário"
                sx={{
                    position: 'fixed', 
                    bottom: 24,       
                    right: 24,        
                }}
                onClick={() => setModalOpen(true)}
            >
                <AddIcon />
            </Fab>

            <PrescriptionModalRouter
                open={isModalOpen}
                onClose={() => setModalOpen(false)}
                onSave={onSavePrescription}
            />
        </>
    )
}